import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
} from '@mui/material';
import React from 'react';
import {
  BooleanField,
  Datagrid,
  DateField,
  Labeled,
  ListBase,
  SelectField,
  TextField,
  useRecordContext,
} from 'react-admin';
import NoResults from '../layout/NoResults';
import { countryChoices } from '../../constants/countries';
import languages from '../../constants/languages';
import { boldDataGridStyle } from '../../constants/style/datagridStyles';
import Pagination from '../layout/Pagination';
import { continentChoices } from '../../constants/continents';

const IpScreeningDetails = () => {
  const record = useRecordContext();
  if (!record) return null;

  return (
    <Grid container spacing={4}>
      <Grid size={{ xs: 12, md: 6 }}>
        <Card variant="outlined">
          <CardHeader title="Geolocation" />
          <Divider />
          <CardContent>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, md: 6 }}>
                <Labeled>
                  <TextField source="postcode" label="Postcode" emptyText="-" />
                </Labeled>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Labeled>
                  <TextField source="city" label="City" emptyText="-" />
                </Labeled>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Labeled>
                  <TextField source="region" label="Region" emptyText="-" />
                </Labeled>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Labeled>
                  <SelectField source="country" label="Country" choices={countryChoices(languages.EN)} emptyText="-" />
                </Labeled>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Labeled>
                  <SelectField source="continent" label="Continent" choices={continentChoices} emptyText="-" />
                </Labeled>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Labeled>
                  <TextField source="timezone" label="Timezone" emptyText="-" />
                </Labeled>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Labeled>
                  <TextField source="latitude" label="Latitude" emptyText="-" />
                </Labeled>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Labeled>
                  <TextField source="longitude" label="Longitude" emptyText="-" />
                </Labeled>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Card variant="outlined">
          <CardHeader title="Network (AS)" />
          <Divider />
          <CardContent>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, md: 6 }}>
                <Labeled>
                  <TextField source="autonomousSystem.asn" label="ASN" emptyText="-" />
                </Labeled>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Labeled>
                  <TextField source="autonomousSystem.name" label="Name" emptyText="-" />
                </Labeled>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Labeled>
                  <TextField source="autonomousSystem.type" label="Type" emptyText="-" />
                </Labeled>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Labeled>
                  <TextField source="autonomousSystem.domain" label="Domain" emptyText="-" />
                </Labeled>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Card variant="outlined">
          <CardHeader title="Flags" />
          <Divider />
          <CardContent>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, md: 6 }}>
                <Labeled>
                  <BooleanField source="isAnycast" label="Anycast" emptyText="-" />
                </Labeled>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Labeled>
                  <BooleanField source="isMobile" label="Mobile" emptyText="-" />
                </Labeled>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Labeled>
                  <BooleanField source="isAnonymous" label="Anonymous" emptyText="-" />
                </Labeled>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Labeled>
                  <BooleanField source="isSatellite" label="Satellite" emptyText="-" />
                </Labeled>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Labeled>
                  <BooleanField source="isHosting" label="Hosting" emptyText="-" />
                </Labeled>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

const IpScreenings = () => {
  const record = useRecordContext();
  return (
    <Card variant="outlined">
      <CardHeader title="IP screenings" />
      <Divider />
      <ListBase
        resource={`entity/ip/${record?.id}`}
        sort={{ field: 'createdAt', order: 'DESC' }}
      >
        <Datagrid
          sx={boldDataGridStyle}
          empty={<NoResults variant="h6" />}
          expand={<IpScreeningDetails />}
        >
          <TextField sortable={false} source="ip" label="IP address" emptyText="-" />
          <SelectField sortable={false} source="country" label="Country" choices={countryChoices(languages.EN)} emptyText="-" />
          <TextField sortable={false} source="city" label="City" emptyText="-" />
          <TextField sortable={false} source="autonomousSystem.name" label="Network" emptyText="-" />
          <BooleanField sortable={false} source="isAnonymous" label="Anonymous" emptyText="-" />
          <DateField sortable source="createdAt" label="Screening date" showTime />
        </Datagrid>
        <Pagination rowsPerPageOptions={[5, 10, 20]} />
      </ListBase>
    </Card>
  );
};

export default IpScreenings;
